export const RESPONSE_TYPES = {
  JSON: 'json',
  BLOB: 'blob',
  TEXT: 'text',
}

export const CONTENT_TYPES = {
  JSON: 'application/json',
  MULTIPART: 'multipart/form-data;',
}
